import { Button, Grid2, Typography } from '@mui/material'
import { useState } from 'react'
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { TextFormField } from '../../shared/components/FormFields/TextFormField';
import { useNavigate } from 'react-router-dom';
import { OrDivider } from '../../shared/utils/CustomDivider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuthStore from '../../shared/store/useAuthStore';
import { motion } from 'framer-motion';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { plainAxios } from '../../assets/nodeApi/postApi/postAuthApi';
import { Link } from 'react-router-dom';
import { fetchData as fetchDataNode } from "../../assets/nodeApi/fetchData";

const CommonNodeLoginForm = ({ role, loginRoute, bottomLine }) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const { login } = useAuthStore()
    const { showToaster } = useToaster();
    const [errorText, setErrorText] = useState("")
    const validationSchema = yup.object().shape({
        identifier: yup.string().required('User Name is required'),
        password: yup.string().required('Password is required').min(8, "Password must be at least 8 characters").required("Password is required"),
    });

    const initialValues = {
        identifier: '',
        password: '',
    };

    const mutation = useMutation({
        mutationFn: (formData) => plainAxios.post(loginRoute, formData),
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {

        mutation.mutate(values, {
            onSuccess: (response) => {
                resetForm();
                const user = response?.data?.data;
                const token = response?.data?.token;
                const refreshToken = response?.data?.refreshToken;

                if (user) {
                    login(user, token);
                    // Fetch additional user details after successful login
                    queryClient.prefetchQuery({
                        queryKey: ["user-info"],
                        queryFn: () => fetchDataNode("details"),
                    });
                    queryClient.removeQueries({ queryKey: ["courses"], exact: false });
                    queryClient.refetchQueries({ queryKey: ["courses"], exact: false });
                    const storedPath = localStorage.getItem("lastVisitedPath") || "/";
                    const storedCourseId = localStorage.getItem("lastVisitedCourseId") || "/";

                    navigate(storedPath, { replace: true });
                    setTimeout(() => {
                        localStorage.removeItem("lastVisitedPath");
                    }, 500);
                } else {
                    showToaster("Error", "Invalid login response", "error");
                }
                resetForm();
            },
            onError: (error) => {
                const status = error.response?.status;
                const message = error.response?.data?.error;

                if (status === 401) {
                    // Unauthorized / Forbidden → treat as invalid credentials
                    setErrorText("Invalid Credentials");
                } else if (message) {
                    // Any other message from backend
                    setErrorText(message);
                } else {
                    // Fallback error
                    showToaster("Error", "Something went wrong during login", "error");
                }
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });
    };



    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}  >
            {() => (
                <Form>
                    <Grid2 container spacing={3}>

                        <Grid2 children size={{ xs: 12, sm: 6, md: 12 }}>
                            <motion.div animate={errorText ? { x: [-5, 5, -5, 5, 0] } : {}} transition={{ duration: 0.3 }}>
                                <Field
                                    name="identifier"
                                    component={TextFormField}
                                    label="User Name"
                                    isRequired={true}
                                    onChange={() => setErrorText("")}
                                />
                            </motion.div>
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 6, md: 12 }}>
                            <motion.div animate={errorText ? { x: [-5, 5, -5, 5, 0] } : {}} transition={{ duration: 0.3 }}>
                                <Field
                                    name="password"
                                    component={TextFormField}
                                    label="Password"
                                    isRequired={true}
                                    type={"password"}
                                    onChange={() => setErrorText("")}
                                />
                            </motion.div>
                            <Link to={`/ConfirmMobile/${role}`}><Typography variant='body2' fontSize={"12px"} textAlign={"end"} my={1}>Forgot Password ??</Typography></Link>
                        </Grid2>

                        {errorText && <Typography variant="body2" fontSize={"10px"} color="#DC143C">{errorText}</Typography>}


                        <Grid2 size={12}>
                            <Button variant='contained' fullWidth type="submit" disabled={mutation.isPending}>{mutation.isPending ? "Logging In" : "Log In"}</Button>
                        </Grid2>
                        <Grid2 children size={12}>
                            <OrDivider text={"Or"} />
                        </Grid2>
                        {bottomLine}


                    </Grid2>
                </Form>
            )}
        </Formik>
    )
}

export default CommonNodeLoginForm













